export default "__VITE_ASSET__BDwhP7DY__"